// Classes.
import { BaseLocator } from "./base.locator";
import { LevelLocatorComponent } from "./level.locator-component";
import { DateLocatorComponent } from "./date.locator-component";
import { WithResultsLocatorComponent } from "./with-results.locator-component";
import { LiveLocatorComponent } from "./live.locator-component";
import { StringLocatorComponent } from "./string.locator-component";
import { SortingLocatorComponent } from "./sorting.locator-component";
import { DetailedLocatorComponent } from "./detailed.locator-component";
import { DisciplineLocatorComponent } from "./discipline.locator-component";
import { YearLocatorComponent } from "./year.locator-component";

export class SeriesItemLocator extends BaseLocator {
  public discipline: DisciplineLocatorComponent;
  public year: YearLocatorComponent;
  public search: StringLocatorComponent;
  constructor() {
    super("seriesList");
    this.addComponentByType("discipline", "discipline");
    this.addComponentByType("year");
    this.addComponentByType("search");
  }
}
